export default {
  setLegalEntities: (state, payload) => (state.legalEntities = payload),
  setLegalEntity: (state, payload) => (state.legalEntity = payload),
  setAssociates: (state, payload) => (state.associates = payload),
  setAdmins: (state, payload) => (state.admins = payload)
}
